<template>
  <router-link
    :to="url"
    :class="{ 'text-gray': quotation.deleted == 1 && styled }"
    :title="quotation.deleted ? '已删除' : quotation.number"
  >
    <slot v-if="$slots.content" name="content"></slot>
    <component :is="element" v-else>{{ quotation.number }}</component>
  </router-link>
</template>
<script>
export default {
  props: {
    quotation: {
      type: Object,
      default: function () {
        return {
          id: 0,
          number: '',
          deleted: 0,
        }
      },
    },
    styled: {
      type: Boolean,
      default: false,
    },
    origin: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    url() {
      let type = ''
      if (this.quotation.status == 5) {
        type = '/done'
      }

      if (this.quotation.deleted == 1) {
        type = '/deleted'
      }
      return (
        '/dashboard' +
        type +
        '/quotations/' +
        +this.quotation.id +
        '?origin=' +
        this.origin
      )
    },
    element() {
      if (this.quotation.deleted == 1 && this.styled) {
        return 'del'
      }
      return 'span'
    },
  },
}
</script>